import b from 'b_';
import { ChevroneKit as Chevrone } from 'education-icons';
import { Button, Text } from 'platform-components';
import React, { useEffect, useState } from 'react';

import './course-container__about.scss';

interface Props {
    slug?: string;
}

export const CourseContainerAbout = ({ slug }: Props) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    useEffect(() => {
        setIsExpanded(false);
    }, [slug]);

    if (!slug) {
        return null;
    }

    return (
        <div className={b('course-container__about', { expanded: isExpanded })}>
            <div className="course-container__about-header">
                <Text id={'library.collection.about.title'} weight={Text.WEIGHT.M} />
            </div>
            <Button
                className="course-container__about-expand-button"
                icon={<Chevrone />}
                onClick={() => setIsExpanded(!isExpanded)}
                rounded
                size={Button.SIZE.L}
                transparencyTheme={Button.TRANSPARENCY_THEME.LIGHT}
                view={Button.VIEW.SECONDARY}
            />
            <div className="course-container__about-content">
                <div className="course-container__about-item">
                    <Text
                        className="course-container__about-item-label"
                        id="library.collection.content"
                        size={Text.SIZE.XS}
                    />
                    <Text
                        className="course-container__about-item-content"
                        id={`library.collection.${slug}.content`}
                        size={Text.SIZE.XL}
                    />
                </div>
                <div className="course-container__about-item">
                    <Text
                        className="course-container__about-item-label"
                        id="library.collection.duration"
                        size={Text.SIZE.XS}
                    />
                    <Text
                        className="course-container__about-item-content"
                        id={`library.collection.${slug}.duration`}
                        size={Text.SIZE.XL}
                    />
                </div>
                <div className="course-container__about-item">
                    <Text
                        className="course-container__about-item-label"
                        id="library.collection.intensity"
                        size={Text.SIZE.XS}
                    />
                    <Text
                        className="course-container__about-item-content"
                        id={`library.collection.${slug}.intensity`}
                        size={Text.SIZE.XL}
                    />
                </div>
            </div>
        </div>
    );
};
